import { Type } from "@themes/pollinator/ui/Type";
import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";

export type Props = {
  children: React.ReactNode;
  id?: string;
  title?: string;
};

export function MarketingSection({ children, id, title }: Props) {
  return (
    <OuterContentContainer as="section" id={id}>
      <div className="flex flex-col gap-8 w-full">
        {title && (
          <Type as="h2" variant="h2" className="max-w-6xl">
            {title}
          </Type>
        )}
        {children}
      </div>
    </OuterContentContainer>
  );
}

export default MarketingSection;

